/* unplugin-vue-components disabled */import script from "./AreaView.vue?vue&type=script&lang=tsx"
export * from "./AreaView.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__